import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Dashboard from "../views/dashboard/Dashboard";
import EditAdminUserInfo from "../views/admin/EditAdminUserInfo";
import EditRole from "../views/admin/EditRole";
import AddRole from "../views/admin/AddRole";
import Login from "../views/Login";
import Register from "../views/Register";
import AddAdminUser from "../views/admin/AddAdminUser";
import EditNavigation from "../views/base/EditNavigation";
import BannerForm from "../views/base/BannerForm";
import ArticleForm from "../views/main/ArticleForm";
import JobForm from "../views/main/JobForm";
import NewsForm from "../views/main/NewsForm";
import GameForm from "../views/main/GameForm";
import PhotoAlbumForm from "../views/base/PhotoAlbumForm";
import FriendLinkForm from "../views/base/FriendLinkForm";
import EditIndexPart from "../views/base/EditIndexPart";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Default",
    redirect: "/admin",
    component: Home
  },
  {
    path: "/admin",
    name: "Admin",
    component: Home,
    redirect: "/admin/dashboard",
    children: [
      {
        path: "/admin/dashboard",
        name: "Dashboard",
        component: Dashboard,
        meta: {
          requireAuth: true
        }
      },
      {
        path: "/admin/editUserInfo/:userId",
        name: "EditUserInfo",
        component: EditAdminUserInfo,
        meta: {
          requireAuth: true
        }
      },
      {
        path: "/admin/editRole/:roleId",
        name: "EditRole",
        component: EditRole,
        meta: {
          requireAuth: true
        }
      },
      {
        path: "/admin/addRole",
        name: "AddRole",
        component: AddRole,
        meta: {
          requireAuth: true
        }
      },
      {
        path: "/admin/addAdminUser",
        name: "AddAdminUser",
        component: AddAdminUser,
        meta: {
          requireAuth: true
        }
      },
      {
        path: "/admin/editNavigation/:navId",
        name: "EditNavigation",
        component: EditNavigation,
        meta: {
          requireAuth: true
        }
      },
      {
        path: "/admin/bannerForm/:bannerId",
        name: "BannerForm",
        component: BannerForm,
        meta: {
          requireAuth: true
        }
      },
      {
        path: "/admin/articleForm/:articleId",
        name: "ArticleForm",
        component: ArticleForm,
        meta: {
          requireAuth: true
        }
      },
      {
        path: "/admin/jobForm/:jobId",
        name: "JobForm",
        component: JobForm,
        meta: {
          requireAuth: true
        }
      },
      {
        path: "/admin/newsForm/:newsId",
        name: "NewsForm",
        component: NewsForm,
        meta: {
          requireAuth: true
        }
      },
      {
        path: "/admin/gameForm/:gameId",
        name: "GameForm",
        component: GameForm,
        meta: {
          requireAuth: true
        }
      },
      {
        path: "/admin/photoAlbumForm/:photoId",
        name: "PhotoAlbumForm",
        component: PhotoAlbumForm,
        meta: {
          requireAuth: true
        }
      },
      {
        path: "/admin/friendLinkForm/:friendLinkId",
        name: "FriendLinkForm",
        component: FriendLinkForm,
        meta: {
          requireAuth: true
        }
      },
      {
        path: "/admin/editIndexPart/:partId",
        name: "EditIndexPart",
        component: EditIndexPart,
        meta: {
          requireAuth: true
        }
      }
    ]
  },
  {
    path: "/login",
    name: "Login",
    component: Login
  },
  {
    path: "/register",
    name: "Register",
    component: Register
  }
];
// noinspection JSUnusedGlobalSymbols
const router = new VueRouter({
  routes
});

export default router;

// 用于创建默认路由
export const createRouter = () =>
  new VueRouter({
    mode: "history",
    routes: [
      {
        path: "/",
        name: "Default",
        redirect: "/admin",
        component: Home
      },
      {
        path: "/admin",
        name: "Admin",
        component: Home,
        redirect: "/admin/dashboard",
        children: [
          {
            path: "/admin/dashboard",
            name: "Dashboard",
            component: Dashboard,
            meta: {
              requireAuth: true
            }
          },
          {
            path: "/admin/editUserInfo/:userId",
            name: "EditUserInfo",
            component: EditAdminUserInfo,
            meta: {
              requireAuth: true
            }
          },
          {
            path: "/admin/editRole/:roleId",
            name: "EditRole",
            component: EditRole,
            meta: {
              requireAuth: true
            }
          },
          {
            path: "/admin/addRole",
            name: "AddRole",
            component: AddRole,
            meta: {
              requireAuth: true
            }
          },
          {
            path: "/admin/addAdminUser",
            name: "AddAdminUser",
            component: AddAdminUser,
            meta: {
              requireAuth: true
            }
          },
          {
            path: "/admin/editNavigation/:navId",
            name: "EditNavigation",
            component: EditNavigation,
            meta: {
              requireAuth: true
            }
          },
          {
            path: "/admin/bannerForm/:bannerId",
            name: "BannerForm",
            component: BannerForm,
            meta: {
              requireAuth: true
            }
          },
          {
            path: "/admin/articleForm/:articleId",
            name: "ArticleForm",
            component: ArticleForm,
            meta: {
              requireAuth: true
            }
          },
          {
            path: "/admin/jobForm/:jobId",
            name: "JobForm",
            component: JobForm,
            meta: {
              requireAuth: true
            }
          },
          {
            path: "/admin/newsForm/:newsId",
            name: "NewsForm",
            component: NewsForm,
            meta: {
              requireAuth: true
            }
          },
          {
            path: "/admin/gameForm/:gameId",
            name: "GameForm",
            component: GameForm,
            meta: {
              requireAuth: true
            }
          },
          {
            path: "/admin/photoAlbumForm/:photoId",
            name: "PhotoAlbumForm",
            component: PhotoAlbumForm,
            meta: {
              requireAuth: true
            }
          },
          {
            path: "/admin/friendLinkForm/:friendLinkId",
            name: "FriendLinkForm",
            component: FriendLinkForm,
            meta: {
              requireAuth: true
            }
          },
          {
            path: "/admin/editIndexPart/:partId",
            name: "EditIndexPart",
            component: EditIndexPart,
            meta: {
              requireAuth: true
            }
          }
        ]
      },
      {
        path: "/login",
        name: "Login",
        component: Login
      },
      {
        path: "/register",
        name: "Register",
        component: Register
      }
    ]
  });
